export default function Gallery() {
  const works = [
    {
      id: 1,
      image: 'https://public.readdy.ai/ai/img_res/ae55c39d2cdaa126b84909fdcd287932.jpg',
      title: '레이저 커팅 청첩장',
      category: '커팅'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20wooden%20name%20plate%20personalized%20text%20metal%20plate%20professional%20marking%20clean%20white%20background%20precision%20engraving%20detailed%20work%20high%20quality%20craftsmanship&width=400&height=400&seq=laser-work-2&orientation=squarish',
      title: '레이저 마킹 명패',
      category: '마킹'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20acrylic%20decorative%20piece%20modern%20design%20geometric%20pattern%20precision%20cutting%20clean%20white%20background%20professional%20photography%20transparent%20material%20detailed%20laser%20work&width=400&height=400&seq=laser-work-3&orientation=squarish',
      title: '아크릴 인테리어 소품',
      category: '커팅'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20leather%20product%20custom%20design%20precision%20marking%20clean%20white%20background%20professional%20photography%20detailed%20engraving%20high%20quality%20leather%20craftsmanship&width=400&height=400&seq=laser-work-4&orientation=squarish',
      title: '가죽 악세사리 각인',
      category: '마킹'
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20wooden%20decorative%20panel%20intricate%20pattern%20precision%20cutting%20clean%20white%20background%20professional%20photography%20detailed%20laser%20work%20beautiful%20design%20artistic%20craftsmanship&width=400&height=400&seq=laser-work-5&orientation=squarish',
      title: '목재 장식 패널',
      category: '커팅'
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20wooden%20photo%20frame%20personalized%20design%20precision%20marking%20clean%20white%20background%20professional%20photography%20detailed%20engraving%20high%20quality%20wood%20craftsmanship&width=400&height=400&seq=laser-work-6&orientation=squarish',
      title: '우드 포토 프레임',
      category: '마킹'
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            작업 갤러리
          </h2>
          <p className="text-lg text-gray-600">
            뉴테크의 정밀한 레이저 가공 작업물을 확인하세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {works.map((work) => (
            <div
              key={work.id}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl bg-gray-100 aspect-square shadow-lg hover:shadow-2xl transition-all duration-300">
                <img
                  src={work.image}
                  alt={work.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="inline-block px-3 py-1 bg-amber-500 text-slate-900 text-xs font-bold rounded-full mb-2">
                    {work.category}
                  </span>
                  <h3 className="text-xl font-bold">{work.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
